var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "page navigation" }, [
    _c(
      "ul",
      { staticClass: "pagination justify-content-center" },
      [
        _c(
          "li",
          { class: [`page-item`, { disabled: _vm.currentPage === 1 }] },
          [
            _c(
              "button",
              {
                staticClass: "page-link bg-success text-light",
                attrs: { disabled: _vm.currentPage === 1 },
                on: {
                  click: function ($event) {
                    return _vm.handlePageChange(1)
                  },
                },
              },
              [_vm._v(_vm._s("<<"))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          { class: [`page-item`, { disabled: _vm.currentPage === 1 }] },
          [
            _c(
              "button",
              {
                staticClass: "page-link bg-success text-light",
                attrs: { disabled: _vm.currentPage === 1 },
                on: {
                  click: function ($event) {
                    return _vm.handlePageChange(_vm.currentPage - 1)
                  },
                },
              },
              [_vm._v(_vm._s("<"))]
            ),
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.getPageNumbers(), function (page, idx_page) {
          return _c(
            "li",
            {
              key: idx_page,
              class: [`page-item`, { active: _vm.currentPage === page }],
            },
            [
              _c(
                "button",
                {
                  staticClass: "page-link",
                  attrs: { disabled: _vm.currentPage === page },
                  on: {
                    click: function ($event) {
                      return _vm.handlePageChange(page)
                    },
                  },
                },
                [_vm._v(_vm._s(page))]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "li",
          {
            class: [
              `page-item`,
              { disabled: _vm.currentPage === _vm.totalPages },
            ],
          },
          [
            _c(
              "button",
              {
                staticClass: "page-link bg-success text-light",
                attrs: { disabled: _vm.currentPage === _vm.totalPages },
                on: {
                  click: function ($event) {
                    return _vm.handlePageChange(_vm.currentPage + 1)
                  },
                },
              },
              [_vm._v(_vm._s(">"))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: [
              `page-item`,
              { disabled: _vm.currentPage === _vm.totalPages },
            ],
          },
          [
            _c(
              "button",
              {
                staticClass: "page-link bg-success text-light",
                attrs: { disabled: _vm.currentPage === _vm.totalPages },
                on: {
                  click: function ($event) {
                    return _vm.handlePageChange(_vm.totalPages)
                  },
                },
              },
              [_vm._v(_vm._s(">>"))]
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }